import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { ChangeEvent, useCallback, useState } from 'react';

export const transformToMaximumSize = (
  width: number,
  height: number,
  maxWidth: number,
  maxHeight: number
): [number, number] => {
  let targetWidth = width;
  let targetHeight = height;

  const scaleX = targetWidth / maxWidth;
  const scaleY = targetHeight / maxHeight;

  if (scaleX < 1 && scaleY < 1) {
    return [targetWidth, targetHeight];
  }

  if (scaleX > scaleY) {
    targetWidth = maxWidth;
    targetHeight = (height * maxWidth) / width;
  } else {
    targetWidth = (width * maxHeight) / height;
    targetHeight = maxHeight;
  }

  return [targetWidth, targetHeight];
};

interface ImageUploadProps {
  setImageFile: (image?: Blob) => void;
  handleSubmit: () => void;
}

export const ImageUpload = ({ handleSubmit, setImageFile }: ImageUploadProps) => {
  const [image, setImage] = useState<HTMLImageElement | undefined>(undefined);
  const handleImageChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }

      const img = new Image();
      const objectUrl = window.URL.createObjectURL(file);

      img.onload = () => {
        window.URL.revokeObjectURL(objectUrl);
        // Transform to max size 500x500
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          return;
        }
        const [width, height] = transformToMaximumSize(
          img.naturalWidth,
          img.naturalHeight,
          500,
          500
        );
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          setImageFile(blob || undefined);
        }, 'image/jpeg');
      };

      img.onerror = () => {
        window.URL.revokeObjectURL(objectUrl);
      };

      img.src = objectUrl;
      setImage(img);
    },
    [setImageFile]
  );

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <Grid container columnSpacing={2} rowSpacing={1} py={1}>
          <Grid item xs={12}>
            <Stack sx={{ height: '36px' }} direction="row" alignItems="center">
              <Typography sx={{ fontSize: '12px', color: '#606060' }}>Item Image</Typography>
              <input
                accept="image/*"
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={handleImageChange}
              />
              {image && (
                <Box
                  component="img"
                  src={image.src}
                  alt="product"
                  sx={{
                    ml: 1,
                    height: '36px',
                    width: '36px',
                    objectFit: 'contain',
                  }}
                />
              )}
              <label htmlFor="raised-button-file">
                <Button
                  size="small"
                  component="span"
                  variant="text"
                  color="primary"
                  sx={{ textTransform: 'none', mt: 2 / 8 }}
                >
                  {image ? (
                    'Change Photo'
                  ) : (
                    <>
                      <AddAPhotoOutlinedIcon
                        sx={{
                          mr: 1,
                          width: '18px',
                          height: '18px',
                          position: 'relative',
                          top: '-2px',
                        }}
                      />
                      Add Photo
                    </>
                  )}
                </Button>
              </label>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </form>
  );
};
